import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const CardStyled = styling("div")({
  borderRadius: "1rem",
  border: `1.5px solid ${Color.grey}`,
  height: "20rem",
  width: "100%",

  transition: "all 0.15s ease-in-out",

  "&:hover": {
    border: `1.5px solid ${Color.black}`,
  },
});

export const CompanyBanner = styling("div")({
  backgroundPosition: "center",
  backgroundSize: "cover",

  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  height: "13.5rem",
  borderRadius: "0.9rem 0.9rem 0 0",
});
